import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';

import {
  ClearButton,
  DatePicker,
  SelectDropDown
} from 'components/common/Elements/Elements';

import { createFilterSize } from 'utils/common';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filterButton,
  filters,
  trigerResetDatePicker,
  resetAllfilters,
  selectLoader,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter
}) => {
  const { t } = useTranslation(['activity']);

  let companySize = [];

  const numberОfFilters = 9;

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  function checkAndSetFilter(key, value) {
    if (!isEqual(filter[key], value)) {
      setFilter({ ...filter, [key]: value, currentPage: 1 });
      // in cross filters after changing the date you need to get new filters
      setStartFilter(!startFilter);
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
  }

  const handleDateChange = value => {
    const key = 'createdAt';
    checkAndSetFilter(key, value);
  };

  (function () {
    createFilterSize(filters.companySize, companySize);
  })();

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <SelectDropDown
        options={filters.protocol}
        input={{ value: filter.protocol, onChange: handleFilter }}
        name={'protocol'}
        label={t('activity:filters.APLICATION_TYPE')}
        multi
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
        uppercase
      />
      <SelectDropDown
        options={filters.port}
        input={{ value: filter.port, onChange: handleFilter }}
        name={'port'}
        label={t('activity:filters.PORT')}
        multi
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <DatePicker
        label={t('activity:filters.FIRST_PAYMENT')}
        input={{
          value: filter.createdAt,
          onChange: handleDateChange
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <SelectDropDown
        options={
          filters.enabled
            ? filters.enabled.map(element => {
                return element ? 'Yes' : 'No';
              })
            : []
        }
        input={{
          value: filter.enabled,
          onChange: handleFilter
        }}
        name={'enabled'}
        label={t('activity:filters.ENABLED')}
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={companySize}
        input={{ value: filter.companySize, onChange: handleFilter }}
        name={'companySize'}
        label={t('activity:filters.COMPANY_SIZE')}
        multi
        renderKey={'label'}
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.plan}
        input={{ value: filter.plan, onChange: handleFilter }}
        name={'plan'}
        label={t('activity:filters.PRICING_PLAN')}
        multi
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.billingCycle}
        input={{ value: filter.billingCycle, onChange: handleFilter }}
        name={'billingCycle'}
        label={t('activity:filters.BILLING_CYCLE')}
        multi
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.customerSuccessEngineer}
        input={{
          value: filter.customerSuccessEngineer,
          onChange: handleFilter
        }}
        name={'customerSuccessEngineer'}
        label={t('activity:about.CS_ENGINEER')}
        multi
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.accountManager}
        input={{
          value: filter.accountManager,
          onChange: handleFilter
        }}
        name={'accountManager'}
        label={t('activity:filters.ACCOUNT_MANAGER')}
        multi
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />

      <ClearButton
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  filters: PropTypes.object,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  selectLoader: PropTypes.bool,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
